import React from 'react';

import {
  matchColortoIcon,
  remappedRubricsToChecks
} from 'pages/Teachers/StrategiesOverview/utils';
import { trackMixpanelEvent } from 'utils/integrations/mixpanel';

import Typography from 'components/Typography';

import styles from './styles.module.scss';

const StrategyRubrics = ({ strategiesBreakdown, user }) =>
  strategiesBreakdown.map(({ strategy, rubrics }, strategyIndex) => (
    <div
      key={`summaryStrategy-${strategyIndex}`}
      className={styles.strategyContainer}
    >
      <Typography
        variant="H-TEXT-3"
        component="h5"
        className={styles.summaryData}
      >
        {strategyIndex + 1}. {strategy}
      </Typography>
      {rubrics.map(({ name, value }, rubricIndex) => (
        <div key={`summaryRubric-${rubricIndex}`} className={styles.innerData}>
          <span
            onClick={() => {
              trackMixpanelEvent(
                user.id,
                '[StrategiesOverview] Teacher attempted to click on rubric icon.'
              );
            }}
          >
            {remappedRubricsToChecks({
              masteryLevel: value,
              color: matchColortoIcon({ valueIcon: value })
            })}
          </span>{' '}
          <Typography variant="S-TEXT-1" className={styles.lineText}>
            {name}
          </Typography>
        </div>
      ))}
    </div>
  ));

export default StrategyRubrics;
